import { AxiosPromise } from "axios";
import Authentication from "../../../domain/authentication/Authentication";
import { AuthenticationRepository } from "../../../domain/authentication/AuthenticationRepository";
import AuthenticationDataSource from "../../../infrastructure/datasource/authentication/AuthenticationDataSource";

export default class LoginResKa {
  constructor(private readonly repository: AuthenticationRepository = new AuthenticationDataSource()) {
  }

  public execute(authentication: Authentication): AxiosPromise {
    return this.repository.login(authentication);
  }
}